export const specInfo = {
  popova: {
    price: 4950,
    discountedPrice: 3960,
    specId: 'tatiana_popova_1648778476',
  },
  shtukatureva: {
    price: 4950,
    discountedPrice: 3960,
    specId: 'svetlana_shtukareva_1647560838',
  },
  gladkovskaya: {
    price: 4950,
    discountedPrice: 3960,
    specId: 'elena_gladkovskaia_1648157764',
  },
  dydychkina: {
    price: 4950,
    discountedPrice: 3960,
    specId: 'olga_dydychkina_1669718498',
  },
  kuznetsova: {
    price: 4950,
    discountedPrice: 3960,
    specId: 'valeriia_kuznecova_1669718807',
  },
  sipyagin: {
    price: 5000,
    discountedPrice: 4000,
    specId: 'dmitrij_sipiagin_1679560134',
  },
  vaisman: {
    price: 3950,
    discountedPrice: 3160,
    specId: 'irina_vajsman_1663153609',
  },
  dontsova: {
    price: 4950,
    discountedPrice: 3950,
    specId: 'margarita_doncova_1647550280',
  },
};
